import { useSelector } from 'react-redux'
import { Currency, Fraction, Trade, TradeType } from '@nominex/nomiswap-sdk'
import BigNumber from 'bignumber.js'
import useUsdtPrice, { useNmxUsdtPrice } from 'hooks/useUsdtPrice'
import { State } from 'state/types'
import { computeCashback } from 'utils/prices'

export default function useNmxCashback(trade: Trade<Currency, Currency, TradeType>): { nmxCashback: BigNumber } {
  const cashbackPercent = useSelector((state: State) => {
    const { farmingLevels, user } = state.affiliate
    const currentLevel = farmingLevels.find(({ name }) => name === user.farmingLevel.currentLevel)
    return currentLevel?.cashback || 0
  })

  let nmxCashback = new BigNumber(0)

  const cashbackFraction = new Fraction(cashbackPercent.toString(), '100')
  const cashback = new BigNumber(computeCashback(trade, cashbackFraction).toFixed(trade.inputAmount.currency.decimals))
  const baseTokenUsdtPrice = new BigNumber(useUsdtPrice(trade.inputAmount.currency)?.toFixed() ?? 0)
  const nmxUsdtPrice = new BigNumber(useNmxUsdtPrice()?.toFixed() ?? 0)

  if (baseTokenUsdtPrice.gt(0) && nmxUsdtPrice.gt(0)) {
    nmxCashback = cashback.times(baseTokenUsdtPrice.div(nmxUsdtPrice))
  }

  return { nmxCashback }
}
